/**
 * Guía: Suscripciones y Facturación.
 *
 * Contenido derivado del capítulo **29** del manual: §0 (aquí 121Pass cobra,
 * al revés que el resto del bloque), §2 (el precio vive por moneda) y §3
 * (los dos estados que se mantienen sincronizados), más el flujo F39.
 *
 * El paso del cobro manual es el que evita una promesa falsa: no hay cobro
 * automático, así que una factura no se marca sola.
 */

import type { TourFlow } from '../types';

const SUSCRIPCIONES_PATH = '/finance-subscriptions';

export const c29Suscripciones: TourFlow = {
  id: 'admin.finance-subscriptions',
  chapter: '29',
  title: 'Suscripciones',
  summary:
    'Lo único que la plataforma cobra hacia adentro: planes por moneda, estados y facturas que se marcan a mano.',
  href: SUSCRIPCIONES_PATH,
  requiresCountry: true,
  estimatedMin: 3,
  steps: [
    {
      id: 'intro',
      title: 'Aquí 121Pass cobra, no paga',
      body:
        'Todo lo demás de Finanzas mueve dinero hacia afuera. Ésta es la excepción: el abono ' +
        'que pagan las compañías por usar la plataforma.',
      route: SUSCRIPCIONES_PATH,
    },
    {
      id: 'price-per-currency',
      title: 'El precio vive por moneda, no en el plan',
      body:
        'Un plan tiene un precio por cada moneda. Si le falta el de la moneda del país de una ' +
        'compañía, **esa suscripción aporta cero y nada falla**. Es lo primero que se mira ' +
        'ante «esta compañía debería estar pagando y no aparece».',
      target: 'admin.subscriptions.kpis',
      placement: 'bottom',
      optionalTarget: true,
    },
    {
      id: 'one-active',
      title: 'Una compañía no tiene dos suscripciones vigentes',
      body:
        'Para cambiarle el plan se modifica la que tiene. Crear una segunda se rechaza, y ' +
        'eso explica el error al intentarlo.',
    },
    {
      id: 'manual-billing',
      title: 'No hay cobro automático',
      body:
        'Ninguna pasarela le pasa el recibo al comercio y la suscripción no se renueva sola ' +
        'cobrando una tarjeta. Alguien genera la factura del periodo y alguien la marca ' +
        'pagada cuando el dinero llega. Por eso una factura sigue pendiente aunque el pago ' +
        'esté hecho.',
    },
    {
      id: 'past-due-does-not-cut',
      title: '«Pago vencido» no corta el servicio',
      body:
        'Es un estado contable. Parar a una compañía es una decisión aparte y explícita: la ' +
        'suscripción vencida no la suspende sola.',
    },
  ],
};
